import { type FC } from "react"

import type { LandingPageBlock } from "@forento/core/models/landing"

import type { NavigationPreview } from "../preview/BlockPreview"
import BlogPostsBlockEditor from "./BlogPostsBlockEditor"
import FaqBlockEditor from "./FaqBlockEditor"
import FeaturesBlockEditor from "./FeaturesBlockEditor"
import FooterBlockEditor from "./FooterBlockEditor"
import GalleryBlockEditor from "./GalleryBlockEditor"
import HeaderBlockEditor from "./HeaderBlockEditor"
import HeroBlockEditor from "./HeroBlockEditor"
import HtmlEmbedBlockEditor from "./HtmlEmbedBlockEditor"
import LeadFormBlockEditor from "./LeadFormBlockEditor"
import ProductHighlightBlockEditor from "./ProductHighlightBlockEditor"
import ProductsBlockEditor from "./ProductsBlockEditor"
import TestimonialsBlockEditor from "./TestimonialsBlockEditor"
import TextBlockEditor from "./TextBlockEditor"
import TwoColumnsBlockEditor from "./TwoColumnsBlockEditor"

type Props = {
	block: LandingPageBlock
	onChange: (block: LandingPageBlock) => void
	onClose: () => void
	navigationPreview: NavigationPreview
}
const BlockEditor: FC<Props> = ({ block, onChange, onClose, navigationPreview }) => {
	switch (block.type) {
		case "header":
			return (
				<HeaderBlockEditor
					block={block}
					onChange={onChange}
					onClose={onClose}
					navigationPages={navigationPreview.headerPages}
					currentPath={navigationPreview.currentPath}
				/>
			)
		case "hero":
			return <HeroBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "html-embed":
			return <HtmlEmbedBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "text":
			return <TextBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "two-columns":
			return <TwoColumnsBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "features":
			return <FeaturesBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "testimonials":
			return <TestimonialsBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "faq":
			return <FaqBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "gallery":
			return <GalleryBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "lead-form":
			return <LeadFormBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "footer":
			return <FooterBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "product-list":
			return <ProductsBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "product-highlight":
			return <ProductHighlightBlockEditor block={block} onChange={onChange} onClose={onClose} />
		case "blog-posts":
			return <BlogPostsBlockEditor block={block} onChange={onChange} onClose={onClose} />
	}
}

export default BlockEditor
